const initKlaviyo = function () {
	const subscribeTriggers = document.querySelectorAll('[href="#subscribe"]');
	window._klOnsite = window._klOnsite || [];
	subscribeTriggers.forEach((el) => {
		el.addEventListener('click', function (e) {
			e.preventDefault();
			window._klOnsite.push(['openForm', window.TCP.klaviyoListId]);
		});
	});

	window.addEventListener('klaviyoForms', function (e) {
		if (e.detail.type == 'submit') {
			console.log('k submit', e.detail);
			if (window.ga) {
				window.ga('send', 'event', 'Klaviyo form', 'form_submit', e.detail.formId);
			}
			if (localStorage) {
				localStorage.klaviyoSubscribed = JSON.stringify(e.detail.metaData);
			}
		}
	});
};
window.addEventListener('DOMContentLoaded', initKlaviyo);
